import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";
import { Badge } from "@/components/ui/badge";
import { Clock } from "lucide-react";

interface PendingPaymentBadgeProps {
  expiresAt: string;
}

export function PendingPaymentBadge({ expiresAt }: PendingPaymentBadgeProps) {
  const { t } = useTranslation("admin");
  const [minutesLeft, setMinutesLeft] = useState(() => {
    const diff = new Date(expiresAt).getTime() - Date.now();
    return Math.max(0, Math.ceil(diff / 60000));
  });

  useEffect(() => {
    const interval = setInterval(() => {
      const diff = new Date(expiresAt).getTime() - Date.now();
      setMinutesLeft(Math.max(0, Math.ceil(diff / 60000)));
    }, 30000);
    return () => clearInterval(interval);
  }, [expiresAt]);

  if (minutesLeft <= 0) {
    return (
      <Badge variant="secondary" className="text-[10px] bg-red-100 text-red-700 border-red-200">
        {t("bookings.pendingPayment.expired")}
      </Badge>
    );
  }

  return (
    <Badge variant="secondary" className="text-[10px] bg-yellow-100 text-yellow-800 border-yellow-300 gap-1">
      <Clock className="h-3 w-3" />
      {t("bookings.pendingPayment.label")} · {t("bookings.pendingPayment.minutesLeft", { minutes: minutesLeft })}
    </Badge>
  );
}
